import moment from 'moment';

const columns = t => [
  {
    title: t('LABEL_USER'),
    dataIndex: 'user',
    width: 200,
  },
  {
    title: t('FIELD_CREATION_DATE'),
    dataIndex: 'created_on',
    render: value =>
      `${moment(value).format('DD/MM/YYYY')} a las ${moment(value).format(
        'HH:mm'
      )}`,
  },
  {
    title: t('DISTRIBUTION_DATE_FIELD'),
    dataIndex: 'date',
    render: value => moment(value).format('MMMM YYYY'),
  },
  {
    title: t('DISTRIBUTION_ACCOUNT_FIELD'),
    dataIndex: 'account',
    ellipsis: true,
  },
  {
    title: t('FIELD_OBSERVATIONS'),
    dataIndex: 'comment',
    ellipsis: true,
  },
];

export default columns;
